'use strict';
if(window.addEventListener) {
	window.addEventListener('load', websiteScrolling);
} else if(window.attachEvent) {
	window.attachEvent('load', websiteScrolling);
} else {
	window.onload = websiteScrolling;
}

function websiteScrolling() {
	if(window.addEventListener) {
		window.addEventListener('scroll', navigationSlider);
	} else if(window.attachEvent) {
		window.attachEvent('scroll', navigationSlider);
	} else {
		window.onscroll = navigationSlider;
	}

	var lastScrollPosition = 0;
	function navigationSlider(event) {
		var scroll_distance = window.pageYOffset || document.documentElement.scrollTop;
		var mobile_header = document.getElementById('mobile-header');

		console.log(scroll_distance);

		if(scroll_distance > 600) {
	        var newScrollPosition = window.scrollY;
	        if (newScrollPosition < lastScrollPosition){
	            var mobile_header_classes = mobile_header.classList;
	        	if(mobile_header_classes != undefined) {
	        		mobile_header.classList.add('active');
	        	} else {
	        		mobile_header.className += ' active ';
	        	}
	        } else{
	            var mobile_header_classes = mobile_header.classList;
		    	if(mobile_header_classes != undefined) {
		    		if(mobile_header.classList.contains('active')) {
		    			mobile_header.classList.remove('active');
		    		}
		    	} else {
		    		var headerHasClass = (" " + mobile_header.className + " ").indexOf(" active ") > -1;
					if(headerHasClass == true) {
						mobile_header.className = mobile_header.className.replace(new RegExp('(?:^|\\s)'+ 'active' + '(?:\\s|$)'), ' ');
					}
		    	}
	        }
	        lastScrollPosition = newScrollPosition;

	    } else {
	    	var mobile_header_classes = mobile_header.classList;
	    	if(mobile_header_classes != undefined) {
	    		if(mobile_header.classList.contains('active')) {
	    			mobile_header.classList.remove('active');
	    		}
	    	} else {
	    		var headerHasClass = (" " + mobile_header.className + " ").indexOf(" active ") > -1;
				if(headerHasClass == true) {
					mobile_header.className = mobile_header.className.replace(new RegExp('(?:^|\\s)'+ 'active' + '(?:\\s|$)'), ' ');
				}
	    	}
	    }
	}

}



	